import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { CrossCircledFilledIcon } from '../icons/cross-circled-filled.icon';

import styles from './subscription-failure-dialog.module.scss';

export type SubscriptionFailureDialogProps = {
  onCancel: () => void;
  reason: 'default' | 'pastDue';
  onClick?: () => void;
};

export const SubscriptionFailureDialog: React.FC<SubscriptionFailureDialogProps> = observer(
  ({ onCancel, reason = 'default', onClick }) => {
    const [messageHeader, setMessageHeader] = useState('Subscription error');
    const [messageBody, setMessageBody] = useState('Something went wrong');
    const [buttonText, setButtonText] = useState('Click');

    useEffect(() => {
      switch (reason) {
        case 'pastDue': {
          setMessageHeader('There are unpaid invoices');
          setMessageBody('Please do the transfer first before adding new creators');
          break;
        }

        default: {
          break;
        }
      }
    }, [reason]);

    return (
      <Dialog
        onClose={onCancel}
        actions={[
          <TextButton key="cancel" text="Cancel" onClick={onCancel} autoFocus={!onClick} />,
          ...(onClick
            ? [
                <ElevatedButton
                  key="click"
                  onClick={onClick}
                  text={buttonText}
                  autoFocus={!!onClick}
                />,
              ]
            : []),
        ]}
      >
        <div className={styles['container']}>
          <div className={styles['icon']}>
            <CrossCircledFilledIcon />
          </div>

          <h1>{messageHeader}</h1>
          <p>{messageBody}</p>
        </div>
      </Dialog>
    );
  },
);
